import VksInviteModule from "../../Components/VksInviteComponents/VksInviteModule"
import "./VksInvitePage.css"
export default function VksInvitePage(){
    return(
        <div className="VksInvitePage">
            <VksInviteModule/>
        </div>
    )
}